var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBaby1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-265 -1390)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 33,
    r: 33,
    transform: "translate(265 1390)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(208.629 1394.06)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(73.312 2.484)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M190.341,10.723a5.89,5.89,0,0,1-5.883-5.884A4.845,4.845,0,0,1,189.3,0a4.009,4.009,0,0,1,4,4,3.34,3.34,0,0,1-3.337,3.337,2.805,2.805,0,0,1-2.8-2.8.665.665,0,0,1,1.329,0,1.475,1.475,0,0,0,1.473,1.473A2.01,2.01,0,0,0,191.973,4,2.678,2.678,0,0,0,189.3,1.329a3.514,3.514,0,0,0-3.51,3.51,4.559,4.559,0,0,0,4.554,4.554.665.665,0,0,1,0,1.329Z",
    transform: "translate(-174.407)",
    fill: "#f0917b"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.201 30.951)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181.8,329H167.3l-1.443,7.413a8.856,8.856,0,1,0,17.385,0Z",
    transform: "translate(-165.69 -329)",
    fill: "#176eb5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.043,336.413,175.486,329H167.3l-1.443,7.413a8.862,8.862,0,0,0,12.786,9.549A8.858,8.858,0,0,1,174.043,336.413Z",
    transform: "translate(-165.69 -329)",
    fill: "#176eb5"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.072)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201.494,343.89A5.785,5.785,0,0,1,195.816,337l1.557-8h8.244l1.557,8a5.78,5.78,0,0,1-5.679,6.891Z",
    transform: "translate(-195.708 -329)",
    fill: "#0cb2c2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.989,336.413,202.432,329h-5.059l-1.557,8a5.79,5.79,0,0,0,7.029,6.732A8.814,8.814,0,0,1,200.989,336.413Z",
    transform: "translate(-195.708 -329)",
    fill: "#0cb2c2"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 9.394)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 9.664)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.198,
    cy: 3.198,
    rx: 3.198,
    ry: 3.198,
    fill: "#ffbd86"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.198,
    cy: 3.198,
    rx: 3.198,
    ry: 3.198,
    transform: "translate(25.723)",
    fill: "#ffbd86"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.198 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.589,131.21a12.863,12.863,0,1,0-1.474.337A12.866,12.866,0,0,0,123.589,131.21Z",
    transform: "translate(-107.122 -106)",
    fill: "#fed2a4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.386,118.862a12.866,12.866,0,0,1,10.73-12.686,12.862,12.862,0,1,0,0,25.371,12.865,12.865,0,0,1-10.73-12.685Z",
    transform: "translate(-107.122 -106)",
    fill: "#ffbd86"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.062 22.858)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.874,258.1a.665.665,0,0,0-.938.064.974.974,0,0,1-1.47,0,.665.665,0,1,0-1,.873,2.3,2.3,0,0,0,3.474,0A.665.665,0,0,0,176.874,258.1Z",
    transform: "translate(-173.3 -257.933)",
    fill: "#313d40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.88,258.1a.665.665,0,0,0-.938.064.974.974,0,0,1-1.47,0,.665.665,0,0,0-1,.873,2.3,2.3,0,0,0,3.474,0A.665.665,0,0,0,291.88,258.1Z",
    transform: "translate(-278.114 -257.933)",
    fill: "#313d40"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.742 25.546)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M202.877,290.736a2.688,2.688,0,0,0-3.8-2.238,3.606,3.606,0,0,1-3.021,0,2.689,2.689,0,1,0,.013,4.884,3.539,3.539,0,0,1,3,0,2.688,2.688,0,0,0,3.812-2.645Z",
    transform: "translate(-192.25 -288.254)",
    fill: "#0cb2c2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.11,
    cy: 2.11,
    rx: 2.11,
    ry: 2.11,
    transform: "translate(3.208 0.575)",
    fill: "#0cb2c2"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaby1);
export default __webpack_public_path__ + "static/media/baby1.fe9e973cf00c4fae02e426f4ddfd2ccd.svg";
export { ForwardRef as ReactComponent };